<template>
  <!-- hide控制：页面下滑时隐藏该区域，页面上滑时才出现。 -->
  <van-sticky
    v-if="tabList.length"
    ref="MyTabbar"
    :offset-top="stickOffsetTop"
    :class="{
      'hp-channel-list-tabar': true,
      'hp-hide': scrollDirection === 1
    }"
  >
    <div class="tab-bar-outer">
      <ul class="tab-bar-inner">
        <li
          class="tab-bar-item"
          :class="{ active: currentTab.name === tab.name }"
          v-for="tab in tabList"
          :key="tab.name"
          @click="onTabChange(tab)"
        >
          {{ tab.title
          }}<i class="tab-bar-item-rate-num" v-if="+tab.rateNum"
            >({{ +tab.rateNum }})</i
          >
        </li>
      </ul>
    </div>
  </van-sticky>
</template>

<script>
import { Sticky } from 'vant'
import { getOffsetTop } from 'lib/tools/domUtil.js'

export default {
  components: {
    [Sticky.name]: Sticky
  },
  props: {
    scrollDirection: Number,
    tabList: {
      type: Array,
      default: () => []
    },
    showZxTabsDistance: Number
  },
  computed: {
    stickOffsetTop() {
      return this.$store.getters['homepage/stickOffsetTop']
    },
    currentTab() {
      return this.$store.state.homepage.currentTab
    },
    distance() {
      return this.$store.state.homepage.distance
    }
  },
  mounted() {},
  methods: {
    onTabChange(tab) {
      if (this.currentTab.name === tab.name) {
        return
      }
      this.$trackEvent('newprofilepages_tab_click', {
        button_name: tab.title
      })

      this.$store.commit('homepage/SET_CURRENT_TAB', tab)
      // 定位到列表开头
      this.$nextTick(() => {
        this.scrollToListBegin()
        // 切换到服务tab计算二级tab展示范围
        if (
          (tab.name === 'service' && this.showZxTabsDistance < 0) ||
          tab.name === 'qingsu'
        )
          this.$emit('tabChange')
      })
    },
    scrollToListBegin() {
      let top = 0
      const { MyTabbar } = this.$refs
      if (MyTabbar) {
        top += getOffsetTop(MyTabbar.$el)
      }
      top -= this.distance.headerHeight
      top -= 3 // 减一点偏移量
      console.info('---------scroll to:', top)
      window.scrollTo(0, top)
    }
  }
}
</script>

<style lang="scss">
$height: 88px;

.hp-channel-list-tabar {
  min-height: $height;

  .tab-bar-outer {
    width: 100%;
    height: $height;
    display: flex;
    align-items: center;
    background-color: #fff;
    margin-bottom: 8px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .tab-bar-inner {
      display: flex;
      align-items: center;
    }
    .tab-bar-item {
      flex-shrink: 0;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #6c798c;
      margin-right: 38px;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #21252d;
        position: relative;
        &::after {
          content: '';
          width: 40px;
          height: 8px;
          background: linear-gradient(297deg, #a2b8fd 0%, #6982fa 100%);
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: -10px;
          border-radius: 10px;
        }
      }
      .tab-bar-item-rate-num {
        font-size: 26px;
        line-height: 32px;
        color: #6c798c;
        font-style: normal;
      }
    }
  }

  .van-sticky--fixed {
    padding-left: 32px;
    background-color: #fff;
    transition: transform 0.2s linear;
    z-index: $hp_zIndex_tababr;
    width: 10rem;
    box-sizing: border-box;
    left: 50%;
    margin-left: -5rem;
  }
}
</style>
